export default class DriveAlreadyCreated extends Error {
    constructor() {
        super(
            "Drive already created. Close the current drive before starting a new one."
        );
    }
}
